import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import { Box, InputAdornment } from '@material-ui/core';
import defaultLocales from 'globals/locales/default';
import { ReactComponent as VisibilityIcon } from 'assets/icons/ui/visibility.svg';
import { ReactComponent as VisibilityOffIcon } from 'assets/icons/ui/visibility-off.svg';
import { getIconStyle } from './FsPasswordInput.style';
import FsSimpleInput from '../FsDefaultInput';
import { FsDefaultInputProps } from '../FsDefaultInput/FsDefaultInput';
import PasswordStrengthChecker from '../FsPasswordStrengthChecker';
import { PasswordInfo } from './FsPasswordInput.style-elements';

interface State {
  password: string;
  showPassword: boolean;
}

type FsPasswordInputProps = FsDefaultInputProps & {
  showStrengthChecker?: boolean;
  showInfo?: boolean;
};

const FsPasswordInput: React.FC<FsPasswordInputProps> = ({
  children,
  value,
  showStrengthChecker = false,
  showInfo = false,
  ...otherInputProps
}) => {
  const iconStyle = getIconStyle();

  const [values, setValues] = React.useState<State>({
    password: '',
    showPassword: false,
  });

  const handleClickReveal = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  return (
    <>
      <FsSimpleInput
        {...otherInputProps}
        type={
          otherInputProps.type === 'password' && !values.showPassword
            ? 'password'
            : 'text'
        }
        value={value}
        placeholder={undefined}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {otherInputProps.type === 'password' && (
                <IconButton
                  onClick={handleClickReveal}
                  onMouseDown={handleMouseDownPassword}
                >
                  {values.showPassword && <VisibilityIcon style={iconStyle} />}
                  {!values.showPassword && (
                    <VisibilityOffIcon style={iconStyle} />
                  )}
                </IconButton>
              )}
            </InputAdornment>
          ),
        }}
      />
      {showStrengthChecker && (
        <Box mt={1}>
          <PasswordStrengthChecker password={`${value}`} />
        </Box>
      )}
      {showInfo && (
        <PasswordInfo>{defaultLocales.passwordInstruction}</PasswordInfo>
      )}
    </>
  );
};

export default FsPasswordInput;
